import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MentorIcon from "/icons/mentor.svg";
import MentorIconActive from "/icons/mentorActive.svg";
import CalendarIcon from "/icons/calendarSession.svg";
import CalendarIconActive from "/icons/calendarSessionActive.svg";
import MsgIcon from "/icons/conversation.svg";
import MsgIconActive from "/icons/conversationActive.svg";

const HeaderComp: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      id: 1,
      label: "Mentors",
      icon: MentorIcon,
      iconActive: MentorIconActive,
      path: "/jeuneInnovateur/mentorat",
    },
    {
      id: 2,
      label: "Conversations",
      icon: MsgIcon,
      iconActive: MsgIconActive,
      path: "/jeuneInnovateur/mentorat/conversations",
    },
    {
      id: 3,
      label: "Sessions programmées",
      icon: CalendarIcon,
      iconActive: CalendarIconActive,
      path: "/jeuneInnovateur/mentorat/sessions",
    },
  ];

  const activeTabFromRoute = menuItems.findIndex((item) =>
    location.pathname.includes(item.path)
  );
  const [activeTab, setActiveTab] = useState(
    activeTabFromRoute >= 0 ? activeTabFromRoute + 1 : 1
  );

  const handleTabClick = (id: number, path: string) => {
    setActiveTab(id);
    navigate(path);
  };

  return (
    <div className="flex bg-[#EBEEF2] rounded-lg p-1 w-fit mx-4 my-2 shadow-sm gap-2">
      {menuItems.map((item) => (
        <div
          key={item.id}
          className={`flex items-center gap-2 px-4 py-2 cursor-pointer text-sm rounded-[6px] transition-all duration-200
            ${
              activeTab === item.id
                ? "bg-white text-[#02709E] shadow font-medium"
                : "text-[#546881] hover:bg-[#F0F6FC] hover:text-[#02709E] hover:shadow-md"
            }`}
          onClick={() => handleTabClick(item.id, item.path)}
        >
          <div className="flex flex-row justify-center items-center gap-2">
            <img
              src={activeTab === item.id ? item.iconActive : item.icon}
              alt={item.label}
              className="w-6 h-6 transition-all duration-200"
            />
            <span className="font-medium text-sm">{item.label}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default HeaderComp;
